<template>
  <div id="ledTagSlider" refs="ledTagSlider" :class="['top-slider-filter', {'expanded': expanded}]">
    <div class="background white-background border-0"></div>
    <perfect-scrollbar
      id="ledTagsSliderPresentation"
      ref="ledTagsSliderPresentation"
      :class="['workspace cstm-ps-scrollbar-vertical', {'has-data': ledTags.length, 'hide-ps-rail-y-onHover': !expanded}]"
      @ps-scroll-y="handleContentScrollY">
      <div id="ledTagSliderContent" class="workspace">

        <el-tag v-for="(tag, indx) in ledTags" :key="indx"
          :class="['el-tag-tagSlider', 'led-dimension', {
            'selected': isTagSelected(tag.value) && !tag._notVisible,
            'not-visible': tag._notVisible
            }]">
          <div class="background-color"></div>

          <div @click="handleLedTagClick(tag)" class="tag-val">
            <span v-if="tag.value === '_toSeeAllData'">{{tag.label}}</span>
            <span v-else-if="tag.showLabel">{{tag.showLabel}}</span>
            <span v-else>{{tag.value}}</span>
          </div>
          <div @click="confirmDeleteTag($event, tag, indx)" class="remove-icon"></div>
        </el-tag>
      </div>
    </perfect-scrollbar>

    <div id="tagSliderCollapseIcon"
      :class="[{'show-icon': showExpandIcon, 'expanded': expanded}]"
      @click="handleExpandComponentIconClick()">
      <el-icon :size="20"><ArrowDown /></el-icon>
    </div>
  </div>
</template>

<script src="./led-tag-slider.js"></script>
<style lang="scss" src="./led-tag-slider.scss"></style>
